// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7) return "static/chunks/7-694f1e16c0798c75.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4095":"3ec73c0600de1a4d","4602":"97651c7715ac2935"}[chunkId] + ".js";
};